import css from "standard/css";

const style = css`
  :root {
    --font-weight-bold: 700;
    --font-weight-medium: 500;
    --font-weight-regular: 400;
  }
`;

export default style;
